import {
    IconLockCloseOutline,
    IconLockOpenOutline,
    IconSync
} from '@iwoca/icons';
import { Button, Text } from '@iwoca/orion-ui';
import { FormattedMessage } from 'react-intl';

import { capitaliseWord } from '../helpers';
import { DrawerContent } from './drawerSlider/DrawerSlider';
import { ErrorMessage } from './drawerSlider/replaceCard/ErrorMessage';
import { usePatchCreditCard } from './drawerSlider/replaceCard/usePatchCreditCard';
import { useGetCreditCardDashboardData } from './useGetCreditCardDashboardData';

export const CreditCardActions = ({
    setDrawerContent
}: {
    setDrawerContent: (content: DrawerContent) => void;
}) => {
    const { activeCard } = useGetCreditCardDashboardData();
    // if no active card, actions won't be shown
    const {
        mutate: performCardAction,
        isLoading,
        isError
    } = usePatchCreditCard(activeCard!.enfuce_card_id);
    const action = activeCard!.status === 'active' ? 'freeze' : 'unfreeze';
    const handleCardAction = () => {
        performCardAction({ action });
    };

    return (
        <>
            <Text className="mb-l mt-2xl text-l font-med">
                <FormattedMessage
                    id="_.credit_card.dashboard.actions.title"
                    defaultMessage="Card actions"
                />
            </Text>
            <Button
                variant="secondary-alt"
                className="mr-m"
                onClick={handleCardAction}
                disabled={isLoading}
            >
                <Text className="my-auto text-m font-med text-primary-40">
                    <FormattedMessage
                        id="_.credit_card.dashboard.actions.freeze_card"
                        defaultMessage="{action} card"
                        values={{ action: capitaliseWord(action) }}
                    />
                </Text>
                {action === 'freeze' ? (
                    <IconLockCloseOutline />
                ) : (
                    <IconLockOpenOutline />
                )}
            </Button>
            <Button
                variant="secondary-alt"
                onClick={() => setDrawerContent('replaceCard')}
            >
                <Text className="my-auto text-m font-med text-primary-40">
                    <FormattedMessage
                        id="_.credit_card.dashboard.actions.replace_card"
                        defaultMessage="Replace card"
                    />
                </Text>
                <IconSync />
            </Button>
            {isError && <ErrorMessage />}
        </>
    );
};
